import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FluidImg from 'Components/Utility/FluidImg';
import useViewport from 'Hooks/useViewport';

function MidPageBanner({
  background,
  foreground,
  mobile,
  externalLink,
  url,
  mobileOverride,
  needsContainer,
}) {
  const Tag = externalLink ? 'a' : Link;
  const formattedUrl = url && !externalLink ? url.split('en/')[1] : url;

  let { isAboveSm } = useViewport();
  if (mobileOverride) isAboveSm = false;

  return (
    <section className={classNames({ container: needsContainer })}>
      <Tag href={formattedUrl} to={formattedUrl}>
        <div className="MidPageBanner">

          <div className="MidPageBanner__contentContainer">
            {isAboveSm &&
              <FluidImg
                src={foreground}
                alt="Sale Message"
                overrideWidth="100"
              />
            }
            <div className="MidPageBanner__background">
              <FluidImg
                src={isAboveSm ? background : mobile}
                alt="Sale Background"
                overrideWidth="100"
              />
            </div>
          </div>
        </div>
      </Tag>
    </section>
  );
}

MidPageBanner.propTypes = {
  background: PropTypes.string,
  foreground: PropTypes.string,
  mobile: PropTypes.string,
  externalLink: PropTypes.bool,
  url: PropTypes.string,
  needsContainer: PropTypes.bool,
};

MidPageBanner.defaultProps = {
  background: '',
  foreground: '',
  mobile: '',
  externalLink: false,
  url: '',
  needsContainer: false,
};

export default MidPageBanner;
